import { useEffect, useState } from "react";
import { React } from "react-dom";
import { ReactComponent as BackIcon } from "../../assets/icons/arrow-left.svg";
import background from "../../assets/images/background.png";
import { StripePriceIDMap } from "../../price-id";
import dataProvider from "../../services/dataProvider";
import { CONTACT_US, FAIL_PAGE_ROUTE, LOGIN_ROUTE, SETUP_ACCOUNT_STEP_ONE_ROUTE, SIGNUP_ROUTE, SUCCESS_PAGE_ROUTE, TERMS_AND_CONDITIONS } from "../../routes";
import firebase from "../../services/firebase";
import {isAuthenticated} from "../../services/firebase";
import authServices from "../../services/authServices";
import axios from "axios" ;
import validatePhoneNumber from "../../utility/validator/phone-no-validation";
import { Link } from "react-router-dom";

// TODO : messges for user details recorded 

const SetupAccountStep2 = ({ history, ...props }) => {
    const db = firebase;

    const baseState = {
        companyName : "",
        corporationAddress : "" ,
        corporationPhoneNumber : ""
    };

    const [formData, setFormData] = useState(baseState);

    const [isLoading, setIsLoading] = useState(false);
    const [phoneError, setPhoneError] = useState(false);

    const [agreedTerms, setagreedTerms] = useState(false);

    useEffect (async ()=>{
        setIsLoading(false);
        setagreedTerms(false);

        if(!isAuthenticated()){
            history.replace(SIGNUP_ROUTE);
        }

        let subscriberInfo = !props.location?.state?.subscriberInfo ;
        // console.log(subscriberInfo)
        if(subscriberInfo?.stepOneCompleted){
            history.replace(SETUP_ACCOUNT_STEP_ONE_ROUTE);
        }

        let res = await axios.get( dataProvider.baseUrl + "checkIfStep2DetailsExists" , { headers : {
            token : authServices.getToken()
        }}); 

        if(res.data.status === "success") {
            //console.log(res.data.userData)
            let complyData = res.data?.userData?.complyData ;
            if(complyData && Object.keys(complyData).length > 0) {
                setFormData(complyData);
            }   
        }
 

    },[])

    async function handleSubmit(e) {
        e.preventDefault();

        const subscriberInfo = {
            priceId : StripePriceIDMap[props.location.state.subscriberInfo.plan],
            ...props.location.state.subscriberInfo,
            ...formData
        } ;

        // contains all variable
        //console.log(subscriberInfo);

        setIsLoading(true);
        let result = await handleCheckout(subscriberInfo);
    }

    const handleCheckout = async (data) => {


        let headers = {
            token : authServices.getToken()
        };

        await axios.post(`${dataProvider.baseUrl}/addStep2AccountDetails`,data,{headers}).catch((err) => {
            alert(err.code,err.message);
            return false ;
        });

        const docRef = await db
            .firestore()
            .collection("customers")
            .doc(authServices.getUID())
            .collection("checkout_sessions")
            .add({
                // automatic_tax: true, // Automatically calculate tax based on the customer's address
                //tax_id_collection: true, // Collect the customer's tax ID (important for B2B transactions)
                tax_rates: [
                    'txr_1JTNDDAOn0O3FLm4BJ1iUCh3',
                  ],
                price: StripePriceIDMap[props.location.state.subscriberInfo.plan],
                success_url: window.location.origin + SUCCESS_PAGE_ROUTE,
                cancel_url: window.location.origin + FAIL_PAGE_ROUTE,
                allow_promotion_codes: true,
            });

        // Wait for the CheckoutSession to get attached by the extension
        docRef.onSnapshot((snap) => {
            const { error, url } = snap.data();
            // setIsLoading(false);
            if (error) {
                // Show an error to your customer and
                // inspect your Cloud Function logs in the Firebase console.
                alert(`An error occured: ${error.message}`);
            }
            if (url) {
                // We have a Stripe Checkout URL, let's redirect.
                window.location.assign(url);
            }
        });
    };

    return (
        <div
            id="chose-plan"
            style={{
                backgroundImage: `url(${background})`,
                minHeight: "100vh",
            }}
        >
            <div className="container pb-5">
                <div className="btn mt-3">
                    <BackIcon
                        width="32"
                        onClick={() => {
                            history.goBack();
                        }}
                    />
                </div>
                <h1 className="text-center text-light mt-5">Setup account</h1>
                <div className="d-flex flex-column align-items-center">
                    <form
                        onSubmit={handleSubmit}
                        className="w-100"
                        style={{ maxWidth: "64rem" }}
                    >
                        <div className="row">
                            <div className="col-lg">
                                <input
                                    style={{ height: "3rem" }}
                                    type="text"
                                    placeholder="Corporation Name *"
                                    value={formData.companyName}
                                    onChange={(e) => setFormData({...formData,companyName : e.target.value })}
                                    className="form-control no-border rounded-0 text-light bg-transparent border-0 border-bottom my-4 h5"
                                />
                                <div className="my-4">
                                    <input
                                        style={{ height: "3rem" }}
                                        type="text"
                                        placeholder="Corporation  Phone Number"
                                        value={formData.corporationPhoneNumber}
                                        onChange={(e) => {
                                            setFormData({...formData,corporationPhoneNumber : e.target.value });
                                            if(!validatePhoneNumber(e.target.value)){
                                                setPhoneError(true);
                                            } else {
                                                setPhoneError(false);
                                            }
                                        }}
                                        className={"form-control no-border rounded-0 text-light bg-transparent border-0 border-bottom h5 " + (phoneError ? "is-invalid" : "")}
                                    />
                                    {phoneError && (
                                        <div className="position-absolute text-danger">
                                            Invalid Phone Number
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-lg">
                                <input
                                    style={{ height: "3rem" }}
                                    type="text"
                                    placeholder="Corporation  Address"
                                    value={formData.corporationAddress}
                                    onChange={(e) => setFormData({...formData,corporationAddress : e.target.value })}
                                    className="form-control no-border rounded-0 text-light bg-transparent border-0 border-bottom my-4 h5"
                                />
                                
                            </div>
                        </div>
                        <div className="d-flex justify-content-center my-5">
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="flexCheckDefault"
                                    checked={agreedTerms}
                                    onChange={(e) => {setagreedTerms(e.target.checked)}}
                                />
                                <label
                                    className="form-check-label text-light"
                                    htmlFor="flexCheckDefault"
                                >
                                    I agree to
                                    <a className="ms-2" target="_blank" href={TERMS_AND_CONDITIONS}>Terms and services</a>
                                </label>
                            </div>
                        </div>
                        <div className="d-flex justify-content-center">

                            {isLoading ? (
                                <button
                                    style={{ height: "3rem" }}
                                    className="d-flex align-items-center btn btn-outline-light rounded-pill px-5 text-btn"
                                disabled>
                                    Processing...
                                    <div className="spinner-border ms-4" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </button>
                            ) : (
                                <button
                                    style={{ height: "3rem" }}
                                    className="btn btn-outline-light rounded-pill px-5 text-btn"
                                    disabled={!agreedTerms}
                                >
                                    Continue to Checkout
                                </button>
                            )}

                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default SetupAccountStep2;
